import React from 'react';
import Text from './Text.js';
import { Tooltip as MUITooltip } from '@mui/material';

/**
 *
 * @param {*} param0
 */
const Tooltip = ({
  children,
  tip,
  placement = 'top',
  customStyle = {},
  arrow = false,
  display = 'block'
}) => {
  if (!tip) {
    return children;
  }
  return /*#__PURE__*/React.createElement(MUITooltip, {
    title: /*#__PURE__*/React.createElement(Text, {
      customStyle: {
        padding: 8,
        lineHeight: 1.2
      },
      medium: true,
      color: "white"
    }, tip),
    placement: placement,
    arrow: arrow
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      ...customStyle,
      display
    }
  }, children));
};
export default Tooltip;